import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    standalone: true,
    imports: [NgOptimizedImage, CommonModule],
    selector: 'app-box',
    templateUrl: './box.component.html',
    styleUrls: ['./box.component.scss'],
})
export class BoxComponent implements OnInit {
    @Input() logoHeader = false;
    @Input() radius = 0;
    @Input() noBodyPadding = false;
    @Input() logoWidth = 0;
    @Input() logoHeight = 0;
    @Input() logoText = '';

    public shouldDisplayRI = false;
    private router: Router = inject(Router);

    ngOnInit(): void {
        const currentDomain = window.location.hostname;

        if (currentDomain === 'platform.riforestry.com') {
            this.shouldDisplayRI = true;
        }
    }

    navigateToHome(): void {
        this.router.navigate(['/']);
    }
}
